export default "__VITE_ASSET__df37aef5__"